import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { DeleteDigitalSignatureModal } from "../../components/delete-digital-signature";
import { PageLayout } from "../../components/page-layout";
import { CardGridPagination } from "../../components/card-grid-pagination/CardGridPagination";
import { QdsStatusEnum } from "../../entities/IQdsRequest";
import { QdsSignatures } from "./QdsSignatures";
import { useDigitalSignatureQualified } from "./useDigitalSignatureQualified";

const SIGNATURES_FILTER_KEY = "qds-signatures-status-filter";

export const QdsSignaturesScreen = () => {
  const {
    documents,
    count,
    onResend,
    loading,
    showDeleteModal,
    onStartDelete,
    closeDeleteModal,
    onDelete,
    deletingSignature,
  } = useDigitalSignatureQualified();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.search) {
      const saved = sessionStorage.getItem(SIGNATURES_FILTER_KEY);
      if (saved) navigate({ search: saved }, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (location.search) {
      sessionStorage.setItem(SIGNATURES_FILTER_KEY, location.search);
    } else {
      sessionStorage.removeItem(SIGNATURES_FILTER_KEY);
    }
  }, [location.search]);

  const queryParams = new URLSearchParams(location.search);
  const currentStatus = queryParams.get("status");
  const showPending = !currentStatus || currentStatus === QdsStatusEnum.PENDING;
  const showSigned = !currentStatus || currentStatus === QdsStatusEnum.SIGNED;

  const handleFilterChange = (statusKey: QdsStatusEnum.PENDING | QdsStatusEnum.SIGNED, checked: boolean) => {
    const otherChecked = statusKey === QdsStatusEnum.PENDING ? showSigned : showPending;
    if (!checked && !otherChecked) return;

    const newParams = new URLSearchParams(location.search);
    newParams.delete("skip");

    if (checked && otherChecked) {
      newParams.delete("status");
    } else if (checked) {
      newParams.set("status", statusKey);
    } else {
      newParams.set("status", statusKey === QdsStatusEnum.PENDING ? QdsStatusEnum.SIGNED : QdsStatusEnum.PENDING);
    }

    navigate({ search: newParams.toString() });
  };

  return (
    <PageLayout title={t("DOCUMENTS.DOCUMENTS_FOR_QUALIFIED_DIGITAL_SIGNINING")} loading={loading}>
      <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
        <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", margin: 0 }}>
          <input
            type="checkbox"
            checked={showPending}
            onChange={(e) => handleFilterChange(QdsStatusEnum.PENDING, e.target.checked)}
          />
          Na čekanju
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", margin: 0 }}>
          <input
            type="checkbox"
            checked={showSigned}
            onChange={(e) => handleFilterChange(QdsStatusEnum.SIGNED, e.target.checked)}
          />
          Potpisano
        </label>
      </div>
      <hr style={{ marginTop: 12, marginBottom: 0 }} />
      <div style={{ paddingTop: 12 }}>
        <QdsSignatures documents={documents} onDelete={onStartDelete} onResend={onResend} mode="signatures" />
        <CardGridPagination totalItems={count} />
      </div>
      <DeleteDigitalSignatureModal
        show={showDeleteModal}
        onDelete={onDelete}
        onCancel={closeDeleteModal}
        isLoading={deletingSignature}
      />
    </PageLayout>
  );
};
